import { TCreateDomainGoal, TDomainGoal, TDomainGrowthZone } from '@/types/GrowthZone.types';
import { api, TCustomAxiosResponse } from '..';
import { WELLNESS_DATA_MULTIPLIER } from '@/constants';
import { apiPaths } from '@/services/api/paths';

export const growthZoneGet = async (): Promise<TDomainGrowthZone[]> => {
  const { data } = await api.get<{ data: TDomainGrowthZone[] }>(apiPaths.growthZone.goals);

  const overallIndex = data.data.findIndex((domainData) => domainData.domain === 'overall');
  const overallElement = data.data.splice(overallIndex, 1)[0];
  const sorted = [overallElement, ...data.data];

  const scoreMultiplied = sorted.map((sortedItem) => ({
    ...sortedItem,
    score: sortedItem.score * WELLNESS_DATA_MULTIPLIER,
  }));

  return scoreMultiplied;
};

export const createGoalPost = async (newDomainGoal: TCreateDomainGoal): Promise<TDomainGoal> => {
  const { data } = await api.post<TCustomAxiosResponse<TDomainGoal>>(apiPaths.growthZone.goals, newDomainGoal);

  const response = data.data;

  return response;
};

export const completeGoalPatch = async (goalID: string): Promise<TDomainGoal> => {
  const { data } = await api.patch(apiPaths.growthZone.toggleGoal(goalID));
  return data.data;
};

export const editGoalPatch = async (goalID: string, editedText: string): Promise<TDomainGoal> => {
  const { data } = await api.patch(apiPaths.growthZone.goalById(goalID), { text: editedText });
  return data.data;
};
